import { render } from "./labelled_checkbox.vue?vue&type=template&id=1427b9eb&scoped=true&lang=pug"
import script from "./labelled_checkbox.vue?vue&type=script&lang=js"
export * from "./labelled_checkbox.vue?vue&type=script&lang=js"

import "./labelled_checkbox.vue?vue&type=style&index=0&id=1427b9eb&lang=scss&scoped=true"

import exportComponent from "../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1427b9eb"]])

export default __exports__